import { expValEquals } from '@atlassian/jira-feature-experiments';
import { useIsEligibleForStorageHardLimitExp } from '../use-is-eligible-for-storage-hard-limit-exp/index.tsx';

type StorageUsage = {
	attachmentStorageAllowed?: number;
	attachmentStorageIsUnlimited?: boolean;
	attachmentStorageUsed?: number;
};

export const useShouldBlockStorageUploads = (
	storageUsage?: StorageUsage,
	isProjectAgnostic?: boolean,
): boolean => {
	const eligible = useIsEligibleForStorageHardLimitExp(isProjectAgnostic);

	if (!eligible) {
		return false;
	}

	if (!storageUsage) {
		return false;
	}

	const { attachmentStorageAllowed, attachmentStorageIsUnlimited, attachmentStorageUsed } =
		storageUsage;

	if (
		attachmentStorageIsUnlimited === true ||
		attachmentStorageUsed === undefined ||
		attachmentStorageAllowed === undefined
	) {
		return false;
	}

	if (
		attachmentStorageUsed >= attachmentStorageAllowed &&
		expValEquals('jira-storage-hard-limit', 'cohort', 'variation')
	) {
		return true;
	}

	return false;
};
